<template>
  <div id="app">
    <div v-if="!submitted">
      <form
        id="new_reservation"
        class="new_reservation"
        @submit.prevent="submit()"
      >
        <ValidationObserver ref="observer">
          <input name="utf8" type="hidden" value="✓" />
          <div class="reservation-form-wrapper">
            <div class="reservation-form">
              <fieldset>
                <div class="row">
                  <div class="col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="first name"
                    >
                      <div class="form-group-wrapper">
                        <div
                          class="form-group form-group--pill adaptive-placeholder string required reservation_first_name"
                          :class="{ 'has-error': errors[0] }"
                        >
                          <label
                            class="control-label string required"
                            tag="div"
                            for="reservation_first_name"
                          >
                             First name
                          </label>
                          <div class="form-control-wrapper">
                            <input
                              id="reservation_first_name"
                              v-model="form.first_name"
                              class="form-control empty string required"
                              type="text"
                              name="reservation[first_name]"
                              :class="{ 'not-empty': form.first_name }"
                              placeholder="Enter your first name"
                            />
                          </div>
                        </div>
                        <span v-if="errors[0]" class="invalid-feedback d-block">{{
                            errors[0]
                          }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="last name"
                    >
                      <div class="form-group-wrapper">
                        <div
                          class="form-group form-group--pill adaptive-placeholder string required reservation_last_name"
                          :class="{ 'has-error': errors[0] }"
                        >
                          <label
                            class="control-label string required"
                            tag="div"
                            for="reservation_last_name"
                          >
                             Last name
                          </label>
                          <div class="form-control-wrapper">
                            <input
                              id="reservation_last_name"
                              v-model="form.last_name"
                              class="form-control empty string required"
                              type="text"
                              name="reservation[last_name]"
                              :class="{ 'not-empty': form.last_name }"
                              placeholder="Enter your last name"

                            />
                          </div>
                        </div>
                        <span v-if="errors[0]" class="invalid-feedback d-block">{{
                            errors[0]
                          }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="email address"
                    >
                    <div class="form-group-wrapper">
                        <div
                          class="form-group form-group--pill adaptive-placeholder email required reservation_email"
                          :class="{ 'has-error': errors[0] }"
                        >
                          <label
                            class="control-label email required"
                            tag="div"
                            for="reservation_email"
                          >
                             Email address</label
                          >
                          <div class="form-control-wrapper">
                            <input
                              id="reservation_email"
                              v-model="form.email"
                              class="form-control empty string email required"
                              type="email"
                              name="reservation[email]"
                              :class="{ 'not-empty': form.email }"
                              placeholder="Enter your email address"

                            />
                          </div>
                        </div>
                        <span v-if="errors[0]" class="invalid-feedback d-block">{{
                            errors[0]
                          }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="phone"
                    >
                    <div class="form-group-wrapper">
                        <div
                          class="form-group form-group--pill adaptive-placeholder email required phone"
                          :class="{ 'has-error': errors[0] }"
                        >
                          <label
                            class="control-label email required"
                            tag="div"
                            for="phone"
                          >
                             Phone</label
                          >
                          <div class="form-control-wrapper">
                            <input
                              id="phone"
                              v-model="form.phone"
                              class="form-control empty string phone required"
                              type="text"
                              name="reservation[phone]"
                              :class="{ 'not-empty': form.phobe }"
                              placeholder="Enter your phone"

                            />
                          </div>
                        </div>
                        <span v-if="errors[0]" class="invalid-feedback d-block">{{
                            errors[0]
                          }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="organization type"
                    >
                      <div class="form-group-wrapper">
                        <div
                          class="form-group form-group--pill form-group--select required reservation_organization_type"
                          :class="{ 'has-error': errors[0] }"
                        >
                          <label class="control-label select required" for="organization_type"
                            >Organization type</label
                          >
                          <div class="form-control-wrapper">
                            <select
                              id="organization_type"
                              class="form-control select required"
                              v-model="form.organization_type"
                            >
                              <option value="">Select organization type</option>
                              <option value="fully-guided">Fully-guided</option>
                              <option value="self-guided">Self-guided</option>
                            </select>
                          </div>
                        </div>
                        <span v-if="errors[0]" class="invalid-feedback d-block">{{
                        errors[0]
                      }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                        <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="accomodation type"
                    >
                      <div class="form-group-wrapper">
                        <div
                          class="form-group form-group--pill form-group--select required reservation_accomodation_type"
                          :class="{ 'has-error': errors[0] }"
                        >
                          <label class="control-label select required" for="accomodation_type"
                            >Accomodation type</label
                          >
                          <div class="form-control-wrapper">
                            <select
                              id="accomodation_type"
                              class="form-control select required"
                              v-model="form.accomodation_type"
                            >
                              <option value="">Select type</option>
                              <option value="standard">Standard class</option>
                              <option value="premium">Premium class</option>
                            </select>
                          </div>
                        </div>
                        <span v-if="errors[0]" class="invalid-feedback d-block">{{
                        errors[0]
                      }}</span>
                      </div>
                    </ValidationProvider>
                      </div>
                </div>
              </fieldset>
                  <fieldset>
                    <div class="row">
                      <div class="col-md-6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          rules="required"
                          name="departure date"
                        >
                          <div class="form-group-wrapper">
                            <div
                              class="form-group form-group--pill adaptive-placeholder string required reservation_departure_date"
                              :class="{ 'has-error': errors[0] }"
                            >
                              <label
                                class="control-label string required"
                                :class="{ 'not-empty': form.departure_date }"
                                tag="div"
                                for="reservation_departure_date"
                              >
                                Departure date
                              </label>
                              <div class="form-control-wrapper">
                                <DatePick
                                  v-model="form.departure_date"
                                  id="reservation_departure_date"
                                  :display-format="'DD.MM.YYYY'"
                                  :is-date-disabled="minDepartureDate"
                                  :input-attributes="{
                                    class:
                                      'form-control empty string required not-empty'
                                  }"
                                />
                              </div>
                            </div>
                            <span v-if="errors[0]" class="invalid-feedback d-block">{{
                                errors[0]
                              }}</span>
                          </div>
                        </ValidationProvider>
                      </div>

                      <div class="col-md-6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          rules="required"
                          name="persons count"
                        >
                          <div class="form-group-wrapper">
                            <div
                              class="form-group form-group--pill adaptive-placeholder integer optional reservation_persons_count"
                              :class="{ 'has-error': errors[0] }"
                            >
                              <label
                                class="control-label integer optional"
                                tag="div"
                                for="reservation_persons_count"
                                >

                                Persons count
                              </label>
                              <div class="form-control-wrapper">
                                <input
                                  id="reservation_persons_count"
                                  v-model="form.persons_count"
                                  class="form-control empty numeric integer optional"
                                  type="number"
                                  step="1"
                                  min="1"
                                  name="reservation[persons_count]"
                                  :class="{ 'not-empty': form.persons_count }"
                                />
                              </div>
                            </div>
                            <span v-if="errors[0]" class="invalid-feedback d-block">{{
                                errors[0]
                              }}</span>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset v-if="multipleRoutes">
                    <div class="row">
                      <div class="col-md-6">
                        <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="route type"
                    >
                      <div class="form-group-wrapper">
                        <div
                          class="form-group form-group--pill form-group--select required reservation_route_id"
                          :class="{ 'has-error': errors[0] }"
                        >
                          <label class="control-label select required" for="route_id"
                            >Route variant</label
                          >
                          <div class="form-control-wrapper">
                            <select
                              id="route_id"
                              class="form-control select required"
                              v-model="form.route_id"
                            >
                              <option value="">Select variant</option>
                              <option v-for="route in routes" :key="route.id" :value="route.id">
                                {{ route.title }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <span v-if="errors[0]" class="invalid-feedback d-block">{{
                        errors[0]
                      }}</span>
                      </div>
                    </ValidationProvider>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="residents__wrapper">
                    <div v-for="resident in form.residents" :key="resident.id" class="residents__wrapper-item">
                      <Resident v-bind.sync="resident" />
                    </div>
                  </fieldset>

                  <ValidationProvider
                    v-slot="{ errors }"
                    rules=""
                    name="note"
                  >
                    <div class="form-group-wrapper">
                      <div
                        class="form-group form-group--pill form-group--pill-block adaptive-placeholder text optional reservation_comment"
                        :class="{ 'has-error': errors[0] }"
                      >
                        <label
                          class="control-label text optional"
                          tag="div"
                          for="reservation_comment"
                          >Note</label
                        >
                        <div class="form-control-wrapper">
                          <textarea
                            id="reservation_comment"
                            v-model="form.comment"
                            class="form-control empty text optional reservation-comment"
                            name="reservation[comment]"
                            :class="{ 'not-empty': form.comment }"
                            placeholder="Please enter any notes or additional information here"
                          >
                          </textarea>
                        </div>
                      </div>
                      <span v-if="errors[0]" class="invalid-feedback d-block">{{
                          errors[0]
                        }}</span>
                    </div>
                  </ValidationProvider>

              <div class="text-center">
                <Gdpr identifier="booking" />
              </div>
              <div class="text-center mt-3">
                <input
                  type="submit"
                  name="commit"
                  value="Request now!"
                  class="btn btn-lg btn-secondary"
                />
              </div>
            </div>
          </div>
        </ValidationObserver>
      </form>
    </div>
    <div v-else>
      <div class="thank-you-block">
        <i class="icon check"></i>
        <h2 class="text-center">Thank you, the request is already on its way to us!</h2>
      </div>
    </div>
  </div>
</template>

<script>
import Resident from "./components/Resident.vue";
import Gdpr from "./components/Gdpr.vue";
import DatePick from "vue-date-pick";

export default {
  name: "ReservationForm",
  components: { Resident, DatePick, Gdpr },
  props: ['tourId', 'routes'],
  data: () => ({
    submitted: false,
    submitError: null,
    form: {
      first_name: "",
      phone: "",
      email: "",
      departure_date: "",
      persons_count: 1,
      comment: "",
      route_id: "",
      accomodation_type: "",
      organization_type: "",
      residents: [],
    }
  }),
  computed: {
    multipleRoutes() {
      return this.routes.length > 1
    },
    dataForSubmit: function() {
      const formData = {};
      Object.assign(formData, this.form);
      formData.tour_id = this.tourId;
      formData.residents.forEach(resident => delete resident.identifier);

      formData.attendees = formData.residents;
      delete formData.residents;

      return { request: formData };
    }
  },
  methods: {
    handleDateRequest(e) {
      this.form.departure_date = e.detail.date
      this.form.organization_type = 'fully-guided'
    },
    minDepartureDate(date) {
      return date < new Date();;
    },
    removeResident(identifier) {
      const index = this.form.residents.findIndex(
        resident => resident.identifier === identifier
      );

      this.form.residents.splice(index, 1);
    },
    addResident() {
      const emptyResident = {
        identifier: Date.now(),
        first_name: "",
        last_name: "",
        bike_rental: ""
      };

      this.form.residents.push(emptyResident);
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.submitError = null;
        this.axios.defaults.headers.common[
          "X-CSRF-Token"
        ] = document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content");

        this.axios
          .post("/api/requests", this.dataForSubmit)
          .then(() => {
            this.submitted = true;
          })
          .catch(() => {
            this.submitError = true;
          });
      } else {
        const firstErrorElement = $(".reservation-form")
          .find(".has-error")
          .first();

        const offset = firstErrorElement.offset().top;

        $("html, body").animate({ scrollTop: offset - 250 }, 100);
      }
    }
  },
  watch: {
    'form.first_name'(newName) {
      this.form.residents[0].first_name = newName;
    },
    'form.last_name'(newName) {
      this.form.residents[0].last_name = newName;
    },
    'form.persons_count': {
      handler(newCount) {
        const currentCount = this.form.residents.length;
        const diff = newCount - currentCount;

        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            this.addResident();
          }
        } else if (diff < 0) {
          this.form.residents.splice(newCount, -diff);
        }
      },
      immediate: true
    }
  },
  mounted() {
    document.addEventListener('requestDate', this.handleDateRequest);
  },
  beforeDestroy() {
    document.removeEventListener('requestDate', this.handleDateRequest);
  },
};

</script>

<style lang="scss">
$vdpColor: #FFB541;

@import "vue-date-pick/src/vueDatePick.scss";

.vdpWithInput {
  width: 100%;
}

.vdpComponent input {
  font-size: 13px;
}

.thank-you-block {
  text-align: center;
  i {
    font-size: 60px;
    color: #FFB541;
  }
  h2 {
    color: #042339;
  }
}
</style>
